import { sliderAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  sliderAnatomy.keys
)

// TODO(scott, 2025-07-30): Figure out why this isn't working
const baseStyle = definePartsStyle({
  filledTrack: {
    bg: 'accent',
  },
})

const rangeSliderTheme = defineMultiStyleConfig({
  baseStyle,
})

export default rangeSliderTheme
